import { Card } from 'antd';
import React from 'react';

interface IProps {
  cardTitle?: any;
  cardExtra?: any;
  cardContent: any;
  cardClassName?: any;
}

export default function CCard(props: IProps) {
  const { cardTitle, cardContent, cardClassName, cardExtra } = props;
  return (
    <Card
      className={cardClassName}
      title={cardTitle}
      extra={cardExtra ? cardExtra : ''}
    >
      {cardContent}
    </Card>
  );
}
